import React from 'react'

import * as Sentry from '@sentry/react'
import LogRocket from 'logrocket'
import mixpanel from 'mixpanel-browser'

const DEV_MODE = '_self' in React.createElement('div')
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper user type
export const identifyUser = (user: any) => {
  if (user.public_id) {
    mixpanel.identify(user.public_id)
    mixpanel.people.set({
      $email: user.email,
      $name: user.first_name + ' ' + user.last_name,
    })
    mixpanel.track('Login')
    LogRocket.identify(user.public_id, {
      name: user.first_name + ' ' + user.last_name,
      email: user.email,
    })
  }
}

export const initAnalytics = () => {
  mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN as string, {
    debug: false,
  })
}

export const captureException = (e: Error) => {
  if (!DEV_MODE) {
    LogRocket.captureException(e)
    Sentry.captureException(e)
  } else {
    // eslint-disable-next-line no-console -- TODO: Replace with proper logging
    console.log('Exception caught: ', e)
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper properties type
export const trackEvent = (name: string, properties?: any) => {
  mixpanel.track(name, properties)
}

export const resetMixpanel = () => {
  mixpanel.reset()
}
